import {Error} from "./Error"
import {Encoding} from "./Encoding"
import {Exception} from "../Exception"
import {Register} from "../../genes/Register"

export const Bytes = Register.global("$hxClasses")["haxe.io.Bytes"] = 
class Bytes extends Register.inherits() {
	new(data) {
		this.length = data.byteLength;
		this.b = new Uint8Array(data);
		this.b.bufferValue = data;
		data.hxBytes = this;
		data.bytes = this.b;
	}
	
	/**
	Copies `len` bytes from `src` into this instance.
	@param pos Zero-based location in `this` instance at which to start writing
	bytes.
	@param src Source `Bytes` instance from which to copy bytes.
	@param srcpos Zero-based location at `src` from which bytes will be copied.
	@param len Number of bytes to be copied.
	*/
	blit(pos, src, srcpos, len) {
		if (pos < 0 || srcpos < 0 || len < 0 || pos + len > this.length || srcpos + len > src.length) {
			throw Exception.thrown(Error.OutsideBounds);
		};
		if (srcpos == 0 && len == src.b.byteLength) {
			this.b.set(src.b, pos);
		} else {
			this.b.set(src.b.subarray(srcpos, srcpos + len), pos);
		};
	}
	
	/**
	Returns a new `Bytes` instance that contains a copy of `len` bytes of
	`this` instance, starting at index `pos`.
	*/
	sub(pos, len) {
		if (pos < 0 || len < 0 || pos + len > this.length) {
			throw Exception.thrown(Error.OutsideBounds);
		};
		return new Bytes(this.b.buffer.slice(pos + this.b.byteOffset, pos + this.b.byteOffset + len));
	}
	
	/**
	Returns the `len`-bytes long string stored at the given position `pos`,
	interpreted with the given `encoding` (UTF-8 by default).
	*/
	getString(pos, len, encoding = null) {
		if (pos < 0 || len < 0 || pos + len > this.length) {
			throw Exception.thrown(Error.OutsideBounds);
		};
		if (encoding == null) {
			encoding = Encoding.UTF8;
		};
		let s = "";
		let b = this.b;
		let i = pos;
		let max = pos + len;
		switch (encoding._hx_index) {
			case 0:
				let debug = pos > 0;
				while (i < max) {
					let c = b[i++];
					if (c < 128) {
						if (c == 0) {
							break;
						};
						s += String.fromCodePoint(c);
					} else if (c < 224) {
						let code = (c & 63) << 6 | b[i++] & 127;
						s += String.fromCodePoint(code);
					} else if (c < 240) {
						let c2 = b[i++];
						let code = (c & 31) << 12 | (c2 & 127) << 6 | b[i++] & 127;
						s += String.fromCodePoint(code);
					} else {
						let c2 = b[i++];
						let c3 = b[i++];
						let u = (c & 15) << 18 | (c2 & 127) << 12 | (c3 & 127) << 6 | b[i++] & 127;
						s += String.fromCodePoint(u);
					};
				};
				break
			case 1:
				while (i < max) {
					let c = b[i++] | b[i++] << 8;
					s += String.fromCodePoint(c);
				};
				break
			
		};
		return s;
	}
	
	/**
	Returns a `String` representation of the bytes interpreted as UTF-8.
	*/
	toString() {
		return this.getString(0, this.length);
	}
	
	/**
	Returns the `Bytes` representation of the given `String`, using the
	specified encoding (UTF-8 by default).
	*/
	static ofString(s, encoding = null) {
		if (encoding == Encoding.RawNative) {
			let buf = new Uint8Array(s.length << 1);
			let _g = 0;
			let _g1 = s.length;
			while (_g < _g1) {
				let i = _g++;
				let c = s.charCodeAt(i);
				buf[i << 1] = c & 255;
				buf[i << 1 | 1] = c >> 8;
			};
			return new Bytes(buf.buffer);
		};
		let a = new Array();
		let i = 0;
		while (i < s.length) {
			let c = s.charCodeAt(i++);
			if (55296 <= c && c <= 56319) {
				c = c - 55232 << 10 | s.charCodeAt(i++) & 1023;
			};
			if (c <= 127) {
				a.push(c);
			} else if (c <= 2047) {
				a.push(192 | c >> 6);
				a.push(128 | c & 63);
			} else if (c <= 65535) {
				a.push(224 | c >> 12);
				a.push(128 | c >> 6 & 63);
				a.push(128 | c & 63);
			} else {
				a.push(240 | c >> 18);
				a.push(128 | c >> 12 & 63);
				a.push(128 | c >> 6 & 63);
				a.push(128 | c & 63);
			};
		};
		return new Bytes(new Uint8Array(a).buffer);
	}
	
	/**
	Returns the `Bytes` representation of the given `BytesData`.
	*/
	static ofData(b) {
		let hb = b.hxBytes;
		if (hb != null) {
			return hb;
		};
		return new Bytes(b);
	}
	static get __name__() {
		return "haxe.io.Bytes"
	}
	get __class__() {
		return Bytes
	}
}

